"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _elements = require("../../../styles/elements");

var _CellWithButton = require("./CellWithButton.styles");

var CellWithButton = function CellWithButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children,
      htmlType = _ref.htmlType;
  return (0, _jsxRuntime.jsx)("button", {
    css: [_elements.button.styles.preflight, _CellWithButton.styles.buttonCell, process.env.NODE_ENV === "production" ? "" : ";label:CellWithButton;"],
    className: (0, _clsx["default"])('grui truncate', className),
    onClick: onClick // defaultProps.htmlType is declared so type will always be set
    // eslint-disable-next-line react/button-has-type
    ,
    type: htmlType,
    children: children
  });
};

CellWithButton.propTypes = {
  className: _propTypes.string,
  onClick: _propTypes.func,
  htmlType: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
CellWithButton.defaultProps = {
  className: undefined,
  onClick: function onClick() {},
  htmlType: 'button',
  children: undefined
};
var _default = CellWithButton;
exports["default"] = _default;
//# sourceMappingURL=CellWithButton.js.map